import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DateTime } from 'luxon';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { createSearchParams, useNavigate } from 'react-router-dom';
import { baseUrl, apiHelper } from 'helpers/util';
import { notify } from 'helpers/globalFunctions';

import RowBox from 'components/RowBox';
import SmallHeading from 'components/SmallHeading';

export default function Form(props) {
    const warehouse = props.warehouse;

    const navigate = useNavigate();
    const [ ledgerEntries, setLedgerEntries ] = useState([]);
    const [ startDate, setStartDate ] = useState(DateTime.now())
    const [ endDate, setEndDate ] = useState(DateTime.now())
    const [ viewOption, setViewOption ] = useState('All')

    const loadLedgerReport = function() {
        const apiParams = { "warehouse": warehouse,
            "start_date": startDate.toFormat('yyyy-MM-dd'),
            "end_date": endDate.toFormat('yyyy-MM-dd'),
            "route": "store_manager.store_ledger" }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                setLedgerEntries(response.json.message.ledger_entries) }
            else { console.log(response.json); }
        })
    }

    const onClickLedgerEntry = function(row) {
        let route = null;
        if (row.entry_type == 'STOCK IN') { route = 'stock_in_entry' }
        else if (row.entry_type == 'STOCK OUT') { route = 'stock_out_entry' }
        else { notify.error({ description: 'This entry does not have correct STOCK IN OUT set. Contact Administrator' });
            return; }
        navigate({ "pathname": `./../../${route}`,
            "search": createSearchParams({
                'store_entry_id': row.name
            }).toString() })
    }

    const getEntryFontColor = function(entryType) {
        if (entryType == 'STOCK IN') return 'green';
        if (entryType == 'STOCK OUT') return 'red';
        return '#145DA0';
    }

    useEffect(function() {
        loadLedgerReport();
    }, [])

    return (
        <Box sx={{ padding: '15px' }}>
            <SmallHeading>Ledger Report</SmallHeading>
            <RowBox>
                <Box sx={{ marginRight: '10px', marginTop: '15px' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setStartDate(newValue); }}
                            value={startDate}
                            inputFormat="dd-MMM-yyyy"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                                label="Start Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ marginRight: '10px', marginTop: '15px' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setEndDate(newValue); }}
                            value={endDate}
                            inputFormat="dd-MMM-yyyy"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                                label="End Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Button sx={{ marginRight: '10px', marginTop: '15px' }}
                    onClick={() => loadLedgerReport()} size="small"
                    variant="outlined">Search</Button>
            </RowBox>
            <Box sx={{ 'marginTop': '10px' }}>
                <ToggleButtonGroup
                    size="small"
                    orientation="horizontal" value={viewOption}
                    exclusive onChange={ (e, v) => setViewOption(v) }>
                    <ToggleButton value="STOCK IN">STOCK IN</ToggleButton>
                    <ToggleButton value="STOCK OUT">STOCK OUT</ToggleButton>
                    <ToggleButton value="All">All</ToggleButton>
                </ToggleButtonGroup>
            </Box>
            <Table sx={{ minWidth: 650 }} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ 'fontWeight': '700' }}>Time</TableCell>
                        <TableCell sx={{ 'fontWeight': '700' }}>Product</TableCell>
                        <TableCell sx={{ 'fontWeight': '700' }} align="right">Quantity</TableCell>
                        <TableCell sx={{ 'fontWeight': '700' }}>Type</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {ledgerEntries.filter(e => viewOption == 'All' || viewOption == e.entry_type)
                    .map((e) => (
                    <TableRow key={e.name} onClick={() => onClickLedgerEntry(e)}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell sx={{ 'color': getEntryFontColor(e.entry_type) }}
                            component="th" scope="row">
                            { DateTime.fromSQL(e.entry_datetime).toFormat('dd-MMM hh:mma') }
                        </TableCell>
                        <TableCell sx={{ 'color': getEntryFontColor(e.entry_type) }}
                            component="th" scope="row">{e.product_name}</TableCell>
                        <TableCell sx={{ 'color': getEntryFontColor(e.entry_type) }}
                            align="right">{e.quantity}</TableCell>
                        <TableCell sx={{ 'color': getEntryFontColor(e.entry_type) }}>
                            {e.entry_type}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </Box>
    );
}
